import * as Utilities from './utility';
import AppUtils from './app-utils';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { start, registerApplication } from 'single-spa';
import _ from 'lodash';
import { displayModules } from './console-art';
import { SESSION_STORAGE_GSCOPE_MODULE_LIST_KEY } from './constants';
import { getMfeReroutingMapping } from './services';
import Cookies from 'universal-cookie';

export const mount = (AppComponent, renderFn) => {
    const cookies = new Cookies();
    Utilities.getMfeApps()
        .then(({ applications }) => {
            const modules = Object.entries(
                applications.reduce((acc, cv) => {
                    acc[cv.moduleName] = acc[cv.moduleName] || [];
                    acc[cv.moduleName].push(_.pick(cv, ['path', 'policyName', 'isPOC', 'isUnrestricted', 'isLocal']));
                    return acc;
                }, {}),
            ).reduce((acc, [moduleName, activeWhen]) => [...acc, { moduleName, activeWhen }], []);
            displayModules(modules);
            sessionStorage.setItem(SESSION_STORAGE_GSCOPE_MODULE_LIST_KEY, JSON.stringify(modules));
            return modules;
        })
        .then((modules) => {
            for (const module of modules) {
                registerApplication({
                    name: module.moduleName,
                    app: () => System.import(module.moduleName),
                    activeWhen: (location) => {
                        return module.activeWhen.some(
                            (activeWhen) =>
                                activeWhen.path === location.pathname &&
                                Utilities.hasPolicy(activeWhen.policyName, activeWhen.isPOC, activeWhen.isUnrestricted),
                        );
                    },
                    customProps: {
                        domElementGetter: () => document.getElementById('routes'),
                    },
                });
            }
        })
        .then(() => Utilities.setMFERouteBasedRolesForMarket())
        .then(() => {
            renderFn(AppComponent, () =>
                start({
                    urlRerouteOnly: true,
                }),
            );
        });
    let currentMfeApp = null;
    window.addEventListener('single-spa:before-app-change', (evt) => {
        if (currentMfeApp) {
            window.location.reload();
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const { newAppStatuses } = evt.detail;
        const isUnderMfeContext = Object.values(newAppStatuses).includes('MOUNTED');
        if (isUnderMfeContext) {
            [currentMfeApp] = Object.entries(newAppStatuses).find(([, status]) => status === 'MOUNTED');
        }
    });
    window.addEventListener('single-spa:before-mount-routing-event', (evt) => {
        const appUtils = AppUtils.get();
        if (appUtils) {
            appUtils.setloading(true);
        }
    });
    window.addEventListener('single-spa:routing-event', (evt) => {
        const appUtils = AppUtils.get();
        if (appUtils) {
            appUtils.setloading(false);
        }
    });
    window.addEventListener('single-spa:before-routing-event', async (evt) => {
        const currentMarket = cookies.get('currentMarket') || 'us';
        const { data } = await getMfeReroutingMapping();
        const locationSearch = window.location.search;
        let redirectTo = _.get(data, [currentMarket, window.location.pathname]);
        if (!redirectTo) {
            redirectTo = _.get(data, ['default', window.location.pathname]);
        }
        if (redirectTo) {
            alert(`We are redirecting to ${redirectTo} Please bookmark/pin your new URL(Module)`);
            window.location.href = window.location.origin + redirectTo + locationSearch;
        }
    });
};
